export var navContainer = '';
export var navStyle = '-mb-px flex flex-1 overflow-auto';
export var tabScrollBar = 'overflow-x-auto max-h-16';
export var fullWidth = 'flex-1';
//# sourceMappingURL=tab-list.styles.js.map